export default "__VITE_ASSET__9iPTz77m__"